import React from "react";
import rgb from '../images/rgb_2023-07-15.jpg';
import ndvi from '../images/ndvi_2023-07-15.png';
import ndwins from '../images/ndwins_2023-07-15.png';
import 'bootstrap/dist/css/bootstrap.css';

function Intro() {
return(
    <div className="container">
        <div className="row">
            <div className="col-sm">
                <div className="card">
                    <img className="card-img-top" src={rgb} alt="Card  cap" style={{width: '400px', height: '243px'}} />
                    <div className="card-body">
                        <h5 className="card-title">Monitorea</h5>
                        <p className="card-text">Visualiza tu cultivo a través de imágenes satelitales de alta resolución, haz un seguimiento del desarrollo vegetativo para la toma decisiones eficiente.</p>
                        
                    </div>
                </div>
             </div>
            <div className="col-sm">
                <div className="card">
                    <img className="card-img-top" src={ndvi} alt="Card  cap" />
                    <div className="card-body">
                        <h5 className="card-title">Mide</h5>
                        <p className="card-text">A partir de imágenes en NDVI y RGB, realiza comparaciones, zonifica problemas y mide el desarrollo del cultivo.</p>
                        
                    </div>
                </div> 
            </div>
            <div className="col-sm">
                <div className="card">
                    <img className="card-img-top" src={ndwins} alt="Card  cap" />
                    <div className="card-body">
                        <h5 className="card-title">Agua</h5>
                        <p className="card-text">Evalúa la condición hídrica del cultivo por medio de imágenes NDWI, administra mejor el suministro del recurso.</p>
                        
                    </div>
                </div> 
            </div>
        </div>
    </div>
    );
}

export default Intro;